define(['services/validators', 'services/converters', 'common/parameterApplications'],
    function(validators, converters, parameterApplications) {
        return {
            create: function() {
                return {
                    key: {validator: validators.string},
                    boundingBox: {validator: validators.boundingBox, converter: converters.boundingBox},
                    protocol: {validator: validators.oneOfValue(['http', 'https'], 'protocol')}
                };
            },
            modifyRequestOptions: function(requestOptions) {
                var boundingBox = requestOptions.boundingBox;
                if (boundingBox) {
                    requestOptions.minLon = boundingBox.minLon;
                    requestOptions.maxLon = boundingBox.maxLon;
                    requestOptions.minLat = boundingBox.minLat;
                    requestOptions.maxLat = boundingBox.maxLat;
                    delete requestOptions.boundingBox;
                }
            },
            /*
        * At this moment it's impossible to map one field to two and more output fields but we need to do this, e.g.
        * bounding box needs to be mapped to topLeft and btmRight. That's why this method tries to fix this
        */
            modifyFields: function(fields) {
                var resultFields = Object.assign({}, fields);

                var coordinateParameterDefinition = {
                    application: parameterApplications.PATH
                };

                resultFields.minLon = coordinateParameterDefinition;
                resultFields.maxLon = coordinateParameterDefinition;
                resultFields.minLat = coordinateParameterDefinition;
                resultFields.maxLat = coordinateParameterDefinition;

                return resultFields;
            }
        };
    });



// WEBPACK FOOTER //
// ./services/copyrights/copyrightsParameters.js